(() => {
  const property = target => target.closest('.product-property');
  const show = (item, visible) => {
    if (!item) return;
    const tooltip = item.querySelector('[role=tooltip]');
    tooltip.hidden = !visible;
    if (visible) {
      tooltip.style.left = '0px';
      const rect = tooltip.getBoundingClientRect();
      tooltip.style.left = (Math.min(0, window.innerWidth - 8 - rect.right) + Math.max(0, 8 - rect.left)) + 'px';
    }
  };
  const keyboardFocus = item => item.querySelector('.product-property-icon').matches(':focus-visible');
  document.addEventListener('pointerdown', event => {
    const icon = event.target.closest('.product-property-icon');
    if (!icon) return;
    event.preventDefault();
    if (icon === document.activeElement) icon.blur();
  });
  document.addEventListener('pointerover', event => {
    if (event.pointerType !== 'touch') show(property(event.target), true);
  });
  document.addEventListener('pointerout', event => {
    const item = property(event.target);
    if (item && !item.contains(event.relatedTarget) && !keyboardFocus(item)) show(item, false);
  });
  document.addEventListener('focusin', event => {
    const item = property(event.target);
    if (item && keyboardFocus(item)) show(item, true);
  });
  document.addEventListener('focusout', event => {
    const item = property(event.target);
    if (item && !item.contains(event.relatedTarget)) show(item, false);
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.product-property').forEach(item => {
      show(item, false);
    });
  });
})();
